import { atom } from 'recoil'

export type TraceUserInfoMix = {
    enProfileStatus: number // 英文简介状态 0初始 1审核驳回 2审核中 3审核通过
    nickName: string // 昵称
    tradeLeverDesc: string //  类型说明：普通用户 1:交易员
    settledInDays: string // 入驻天数(从他在平台注册开始)
    headMaxPic: string // 头像大图
    settledStartTime: string // 开始入驻时间
    userId: string //  用户ID
    headPic: string // 头像
    tradeLeverStatus: string // 状态 1可用 2停用
    totalMargin: string // 累计跟单本金-普通用户
    totalProfit: string // 累计净利润-普通用户
    followTraders: string // 跟随交易员人数-普通用户
    todaySplitProfit: string // 今日分润-交易员
    yesterdaySplitProfit: string // 昨日分润-交易员
    waitProfit: string // 待分润
    totalSplitProfit: string // 包含当天分润的累计分润-交易员
    sumProfit: string // 不包含当天分润的累计分润-交易员
    tradeLever: number // 0:普通用户 1:交易员 -1?
    isNewTips: false // 是否有新的跟单提醒
    showEquity: false // 是否开启显示总权益
    certificationType: 0 // 0 未认证； 1： 已认证。ps: 没有审核中状态
    allEquity: number
}

export function createTraceUserInfoMix(): TraceUserInfoMix {
    return {
        enProfileStatus: 0,
        totalProfit: '',
        nickName: '',
        tradeLeverDesc: '',
        settledInDays: '',
        headMaxPic: '',
        settledStartTime: '',
        userId: '',
        headPic: '', // 头像
        tradeLeverStatus: '',
        totalMargin: '',
        todaySplitProfit: '',
        followTraders: '',
        yesterdaySplitProfit: '',
        waitProfit: '',
        totalSplitProfit: '',
        sumProfit: '',
        tradeLever: -1,
        isNewTips: false,
        showEquity: false,
        certificationType: 0,
        allEquity: 0
    }
}
/**
 * TraceUserInfoMix 信息
 */
export const MixSpotTraceUserInfoState = atom({
    key: 'mix-spot-trace-user-info-state',
    default: createTraceUserInfoMix()
})

/**
 * 可用币对
 */
export const MixSpotOpenSymbolState = atom({
    key: 'mix-spot-open-symbol-state',
    default: []
})

// allTraceOrdersSpot: [],
export const MixSpotAllTraceOrdersState = atom({
    key: 'mix-spot-all-trace-orders-state',
    default: []
})
